<template>
<div class="chapter">
<div class="inner_page">
<h1 class="BookTitle">The Pink Umbrella</h1>
<h2 class="BookSubtitle" style="margin-top:60px;">A Pat and Jean Abbott Mystery</h2>
<p class="author" style="margin-top:60px;">Frances Crane</p>
<p class="center" style="margin-top:80px;"><img alt="image" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?41ec177e